// extracted by mini-css-extract-plugin
export var addViewLink = "_13-1";
export var availabilityIcon = "_13-16";
export var availabilitySelectionIcon = "_13-15";
export var backButton = "_13-2";
export var backIcon = "_13-z";
export var conversationCount = "_13-3";
export var dragHandle = "_13-5";
export var dropdown = "_13-e";
export var dropdownIcon = "_13-7";
export var dropdownOption = "_13-6";
export var dropdownTriangle = "_13-d";
export var expand = "_13-f";
export var folder = "_13-i";
export var folderItem = "_13-c";
export var icon = "_13-8";
export var iconRow = "_13-9";
export var image = "_13-a";
export var logo = "_13-b";
export var navContainer = "_13-h";
export var navigationFooter = "_13-g";
export var pageShell = "_13-0";
export var placeholderAvailable = "_13-11";
export var placeholderBox = "_13-14";
export var placeholderBusy = "_13-13";
export var placeholderUnavailable = "_13-12";
export var profile = "_13-k";
export var profileContainer = "_13-m";
export var profileDropdown = "_13-n";
export var profileImage = "_13-l";
export var profileMain = "_13-o";
export var profileSubtitle = "_13-q";
export var profileTitle = "_13-p";
export var reorderIcon = "_13-r";
export var sentLine = "_13-u";
export var settingsHeader = "_13-s";
export var sidenavTextColor = "_13-y";
export var spamLine = "_13-t";
export var subitemWithTag = "_13-4";
export var supportItems = "_13-j";
export var teamText = "_13-10";
export var viewLine = "_13-x";
export var viewLineButton = "_13-w";
export var viewLineButtons = "_13-v";